const setProv = payload => {
  return {
    type: "setProv",
    payload
  };
};

export default setProv;